import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Input,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import {
  blockUser,
  blockorUnblockUser,
  removeUserAccount,
  activateCard,
  unblockUser,
  enableSelfieBypass,
  disableSelfieBypass,
} from "../../../service/user-detail-service";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../common/notification-message/notification";
import { useHistory, useLocation } from "react-router-dom";

import Loading from "../../loader/loader";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { getblockReason } from "./../../../../views/service/user-detail-service";
import { getuserProfileDetail } from "./../../../service/user-detail-service";
import { message } from "antd";
import { getUserRoleName } from "../../azureLogin/authUtility";

const Status = ({
  allUsersObject,
  id,
  getBackMethod,
  profileloading,
  setProfileloading,
}) => {
  const history = useHistory();
  const [modalShow, setModalShow] = useState(false);

  const [showBlockModal, setshowBlockModal] = useState(false);
  const [showRemoveModal, setshowRemoveModal] = useState(false);
  const [modalShow3, setModalShow3] = useState(false);
  const [buttonloading, setButtonloading] = useState(false);
  const [blockReason, setBlockReason] = useState([]);
  const [blockReasonId, setBlockReasonId] = useState();
  const [reason, setReason] = useState("");
  const [temp, setTemp] = useState(false);
  const [showActivateModal, setshowActivateModal] = useState(false);
  const [showSelfieBypassModal, setshowSelfieBypassModal] = useState(false);
  const [selfieBypassReason, setSelfieBypassReason] = useState("");

  const roleName = getUserRoleName()

  let isAdmin = roleName === "Admin" || false;
  let isSuperAdmin = roleName === "SuperAdmin" || false;

  const blockModalYesClicked = (status) => {
    setButtonloading(true);
    if (allUsersObject && allUsersObject.appStatus !== 2) {
      blockUser(id, blockReasonId)
        .then((blockorUnblockUserRes) => {
          setButtonloading(false);

          setshowBlockModal(false);

          openNotificationWithIcon(
            notificationStrings.success,
            "User blocked successfully"
          );
          getuserProfileDetailById(id);
        })
        .catch((blockorUnblockUserErr) => {
          setButtonloading(false);
          setshowBlockModal(false);
        });
    } else {
      unblockUser(id)
        .then((blockorUnblockUserRes) => {
          setButtonloading(false);
          setshowBlockModal(false);
          // console.log({ blockorUnblockUserRes });
          // message.success("User unblocked successfully");
          openNotificationWithIcon(
            notificationStrings.success,
            "User unblocked successfully"
          );
          getuserProfileDetailById(id);
          setReason("");
          // setProfileloading(false)
        })
        .catch((blockorUnblockUserErr) => {
          setButtonloading(false);
          console.log("error2", blockorUnblockUserErr);
          setshowBlockModal(false);
        });
    }
  };
  const getuserProfileDetailById = (id) => {
    console.log(id);
    setProfileloading(true);
    getuserProfileDetail(id)
      .then((res) => {
        console.log(res);
        setProfileloading(false);
        getBackMethod(res && res.data);
      })
      .catch((err) => {
        // message.error("Something went wrong");
        setProfileloading(false);
        console.log(err);
        getBackMethod([]);
      });
  };

  const removeAccountClicked = (id) => {
    setButtonloading(true);
    removeUserAccount(id)
      .then((removeUserAccountRes) => {
        setButtonloading(false);
        setshowRemoveModal(false);
        // message.success("User removed successfully");
        openNotificationWithIcon(
          notificationStrings.success,
          "User removed successfully"
        );
        history.push("/admin/registered-users");
      })
      .catch((removeUserAccountErr) => {
        setButtonloading(false);
        setshowRemoveModal(false);
        // message.success("something went wrong");
      });
  };
  const activateCardClicked = () => {
    setButtonloading(true);
    activateCard(id)
      .then((activateCardRes) => {
        setButtonloading(false);

        setshowActivateModal(false);

        openNotificationWithIcon(
          notificationStrings.success,
          "Card Activate successfully"
        );
        getuserProfileDetailById(id);
      })
      .catch((activateCardRes) => {
        setButtonloading(false);
        setshowActivateModal(false);
      });
  };

  const selfieBypassModalYesClicked = () => {
    setButtonloading(true);
    
    const isEnabling = !(allUsersObject && allUsersObject.isSelfieBypassActive);
    
    if (isEnabling) {
      enableSelfieBypass(id, selfieBypassReason.value)
        .then((response) => {
          setButtonloading(false);
          setshowSelfieBypassModal(false);
          
          openNotificationWithIcon(
            notificationStrings.success,
            response.data.message || "Selfie bypass enabled successfully"
          );
          
          getuserProfileDetailById(id);
          setSelfieBypassReason("");
        })
        .catch((error) => {
          setButtonloading(false);
          setshowSelfieBypassModal(false);
          
          const errorMessage = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Failed to enable selfie bypass";
          
          openNotificationWithIcon(
            notificationStrings.error,
            errorMessage
          );
        });
    } else {
      disableSelfieBypass(id)
        .then((response) => {
          setButtonloading(false);
          setshowSelfieBypassModal(false);
          
          openNotificationWithIcon(
            notificationStrings.success,
            response.data.message || "Selfie bypass disabled successfully"
          );
          
          getuserProfileDetailById(id);
        })
        .catch((error) => {
          setButtonloading(false);
          setshowSelfieBypassModal(false);
          
          const errorMessage = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Failed to disable selfie bypass";
          
          openNotificationWithIcon(
            notificationStrings.error,
            errorMessage
          );
        });
    }
  };

  const handleChangeModal = () => {
    setModalShow(false);
    setshowBlockModal(false);
  };
  const handleChangeModal1 = () => {
    setshowRemoveModal(false);
    setModalShow3(false);
  };

  useEffect(() => {
    const breason = async () => {
      let reasonRes = await getblockReason();
      setBlockReason(reasonRes);
      console.log("BLOCK REASON", blockReason);
    };
    breason();
  }, [getBackMethod]);
  const getAppStatus = (val) => {
    console.log(val);
    if (val === 0) {
      return "Active";
    } else if (val === 1) {
      return "Verified";
    } else if (val === 2) {
      return "Blocked";
    }
  };

  return (
    <>
      <Card style={{ marginBottom: "10px" }}>
        <CardBody>
          <CardTitle tag="h1" className="user-verification-header mb-3">
            Status
          </CardTitle>
          {profileloading ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Loading style={{ width: "10px", height: "10px" }} />
            </div>
          ) : (
            <>
              <div className="row form-group al-center">
                <label
                  className="form-control-label col-lg-5 col-md-5"
                  style={{ padding: "0px" }}
                >
                  App
                </label>
                <label className="form-control-label col-lg-0.5 col-md-0.5">
                  :
                </label>
                <label
                  className=" col-lg-6 col-md-6"
                  style={{ paddingRight: "0px" }}
                >
                  {getAppStatus(allUsersObject && allUsersObject.appStatus)}
                </label>
                <label
                  className="form-control-label col-lg-5 col-md-5"
                  style={{ padding: "0px" }}
                >
                  Type
                </label>
                <label className="form-control-label col-lg-0.5 col-md-0.5">
                  :
                </label>
                <label
                  className=" col-lg-6 col-md-6"
                  style={{ paddingRight: "0px" }}
                >
                  {allUsersObject && allUsersObject.type}
                </label>

                <Button
                  className="status-sub-btn"
                  color="primary"
                  onClick={() => setshowBlockModal(true)}
                >
                  {allUsersObject && allUsersObject.appStatus === 2
                    ? "UnBlock"
                    : "Block"}
                </Button>
                <Button
                  className="status-sub-btn"
                  color="primary"
                  onClick={() => setshowSelfieBypassModal(true)}
                >
                  {allUsersObject && allUsersObject.isSelfieBypassActive
                    ? "Disable Selfie Bypass"
                    : "Enable Selfie Bypass"}
                </Button>
                {(isAdmin || isSuperAdmin) && (
                  <Button
                    className=" status-sub-btn"
                    color="primary"
                    onClick={() => setshowRemoveModal(true)}
                  >
                    Remove Account
                  </Button>
                )}
              </div>

              <div className="row form-group al-center">
                <label
                  className="form-control-label col-lg-5 col-md-5"
                  style={{ padding: "0px" }}
                >
                  Card
                </label>
                <label className="form-control-label col-lg-0.5 col-md-0.5">
                  :
                </label>
                <label
                  className=" col-lg-6 col-md-6"
                  style={{ paddingRight: "0px" }}
                >
                  {allUsersObject && allUsersObject.cardStatus}
                </label>

                {isSuperAdmin &&
                  allUsersObject &&
                  allUsersObject.cardStatus !== "Active" && (
                    <Button
                      className="status-sub-btn"
                      color="primary"
                      onClick={() => setshowActivateModal(true)}
                    >
                      Activate
                    </Button>
                  )}
              </div>

              <div className="row form-group al-center">
                <label
                  className="form-control-label col-lg-5 col-md-5"
                  style={{ padding: "0px" }}
                >
                  RAK Profile
                </label>
                <label className="form-control-label col-lg-0.5 col-md-0.5">
                  :
                </label>
                <label
                  className=" col-lg-6 col-md-6"
                  style={{ paddingRight: "0px" }}
                >
                  {allUsersObject && allUsersObject.rakProfileStatus
                    ? allUsersObject.rakProfileStatus
                    : "Not Created"}
                </label>
              </div>
            </>
          )}
        </CardBody>
      </Card>

      <BlockModal
        show={showBlockModal}
        reason={reason}
        setReason={setReason}
        allUsersObject={allUsersObject}
        onHide={() => setshowBlockModal(false)}
        onClickChange={(status) => blockModalYesClicked(status)}
        buttonloading={buttonloading}
        setBlockReasonId={setBlockReasonId}
      />

      <ConformationaRemoveAccount
        show={showRemoveModal}
        onHide={() => setshowRemoveModal(false)}
        onClickChange={() => removeAccountClicked(id)}
        buttonloading={buttonloading}
      />
      <ConformationaActivateAccount
        show={showActivateModal}
        onHide={() => setshowActivateModal(false)}
        onClickChange={activateCardClicked}
        buttonloading={buttonloading}
      />
      <SelfieBypassModal
        show={showSelfieBypassModal}
        reason={selfieBypassReason}
        setReason={setSelfieBypassReason}
        allUsersObject={allUsersObject}
        onHide={() => setshowSelfieBypassModal(false)}
        onClickChange={selfieBypassModalYesClicked}
        buttonloading={buttonloading}
      />
    </>
  );
};

const BlockModal = ({
  show,
  onHide,
  onClickChange,
  allUsersObject,
  setBlockReasonId,
  buttonloading,
  reason,
  setReason,
}) => {
  const handleReason = (selectedOption) => {
    console.log("onChange", selectedOption);
    setReason(selectedOption);
    setBlockReasonId(selectedOption.id);
  };
  const blockReasonOptions = [
    { id: 1, value: "Fake Registration", label: "Fake Registration" },
    { id: 2, value: "Compromised Login", label: "Compromised Login" },
    { id: 3, value: "Suspicious trx noticed", label: "Suspicious trx noticed" },
  ];

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to{" "}
        {allUsersObject && allUsersObject.appStatus === 2 ? "Unblock" : "Block"}{" "}
        this user?
        {allUsersObject.appStatus !== 2 && (
          <div style={{ margin: "5% 0", display: "flex" }}>
            <FormGroup style={{ paddingTop: "8px" }}>
              <label style={{ paddingRight: "20px" }}>Reason :</label>
            </FormGroup>
            <div style={{ width: "75%" }}>
              <Select
                placeholder="Reason For Block"
                onChange={handleReason}
                options={blockReasonOptions}
                value={reason}
              />
            </div>{" "}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer style={{ paddingTop: "10px" }}>
        <Button variant="secondary" onClick={onHide}>
          No
        </Button>
        <Button
          variant="primary"
          color="primary"
          disabled={buttonloading === true ? true : false}
          onClick={() =>
            onClickChange(allUsersObject && allUsersObject.appStatus)
          }
        >
          {buttonloading ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Loading color="white" width="20px" height="20px" />
            </div>
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
function ConformationaRemoveAccount(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to remove the account?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          No
        </Button>
        <Button
          variant="primary"
          color="primary"
          disabled={props.buttonloading === true ? true : false}
          onClick={props.onClickChange}
        >
          {props.buttonloading ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Loading color="white" width="20px" height="20px" />
            </div>
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
function ConformationaActivateAccount(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to activate this card?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          No
        </Button>
        <Button
          variant="primary"
          color="primary"
          disabled={props.buttonloading === true ? true : false}
          onClick={props.onClickChange}
        >
          {props.buttonloading ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Loading color="white" width="20px" height="20px" />
            </div>
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const SelfieBypassModal = ({
  show,
  onHide,
  onClickChange,
  allUsersObject,
  buttonloading,
  reason,
  setReason,
}) => {
  const handleReason = (selectedOption) => {
    console.log("onChange", selectedOption);
    setReason(selectedOption);
  };
  
  const selfieBypassReasonOptions = [
    { id: 1, value: "No camera device", label: "No camera device" },
    { id: 2, value: "Could not verify", label: "Could not verify" },
  ];

  const isEnabling = !(allUsersObject && allUsersObject.isSelfieBypassActive);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to{" "}
        {isEnabling ? "enable" : "disable"}{" "}
        selfie bypass for this user?
        {isEnabling && (
          <div style={{ margin: "5% 0", display: "flex" }}>
            <FormGroup style={{ paddingTop: "8px" }}>
              <label style={{ paddingRight: "20px" }}>Reason :</label>
            </FormGroup>
            <div style={{ width: "75%" }}>
              <Select
                placeholder="Reason For Selfie Bypass"
                onChange={handleReason}
                options={selfieBypassReasonOptions}
                value={reason}
              />
            </div>{" "}
          </div>
        )}
        {allUsersObject && allUsersObject.isSelfieBypassActive && allUsersObject.selfieBypassExpiresAt && (
          <div style={{ marginTop: "10px", fontSize: "14px", color: "#666" }}>
            Current bypass expires at: {new Date(allUsersObject.selfieBypassExpiresAt + 'Z').toLocaleString()}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer style={{ paddingTop: "10px" }}>
        <Button variant="secondary" onClick={onHide}>
          No
        </Button>
        <Button
          variant="primary"
          color="primary"
          disabled={buttonloading === true || (isEnabling && !reason) ? true : false}
          onClick={onClickChange}
        >
          {buttonloading ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Loading color="white" width="20px" height="20px" />
            </div>
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Status;
